"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var GrabIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M18 11.002v-1.5c0-.132.054-.258.15-.352a.537.537 0 01.738-.006L22 12l-3.124 2.867a.533.533 0 01-.354.133.512.512 0 01-.522-.502v-1.496h-5V18h1.498c.277 0 .502.234.502.522a.533.533 0 01-.133.354L12 22l-2.856-3.112a.537.537 0 01.006-.738.492.492 0 01.352-.15H11v-4.998H6v1.496a.512.512 0 01-.522.502.533.533 0 01-.354-.133L2 12l3.112-2.856a.537.537 0 01.738.006c.096.094.15.22.15.352v1.5h5V6H9.502a.492.492 0 01-.352-.15.537.537 0 01-.006-.738L12 2l2.867 3.124a.533.533 0 01.133.354.512.512 0 01-.502.522H13v5.002h5z"
  }));
});
GrabIcon.category = 'Navigation';
var _default = GrabIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/GrabIcon.js
// module id = 1088
// module chunks = 0